/**
 * A link that leaves the app (spec: external links open in a new tab with
 * rel="noopener noreferrer"), and says so to screen readers. URLs only,
 * never data: the target apps enforce their own access.
 */
export default function ExternalLink({ href, className = '', children, ...rest }) {
  return (
    <a href={href} {...rest} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}
